import { render } from "./RechtlicheHinweise.vue?vue&type=template&id=22b40b85&scoped=true"
import script from "./RechtlicheHinweise.vue?vue&type=script&lang=js"
export * from "./RechtlicheHinweise.vue?vue&type=script&lang=js"

import "./RechtlicheHinweise.vue?vue&type=style&index=0&id=22b40b85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b40b85"]])

export default __exports__